import type { TaxDashboardSummary } from '@shared/api';
import { IconArrowRight } from '@shared/ui/icons';
import { formatMillions } from '../financierFormat';
import {
  Section,
  SectionHeader,
  SectionTitle,
  SectionLink,
  TaxSummaryGrid,
  MetricBox,
  MetricLabel,
  MetricValue,
  MetricNote,
} from './styled';

interface TaxPositionSectionProps {
  tax: TaxDashboardSummary;
}

export function TaxPositionSection({ tax }: TaxPositionSectionProps) {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Налоговая позиция ЕНС и расчёт чистого НДС</SectionTitle>
        <SectionLink to="/agents/finance/working-capital">
          Календарь ЕНС и авансы
          <IconArrowRight size={14} />
        </SectionLink>
      </SectionHeader>
      <TaxSummaryGrid>
        <MetricBox>
          <MetricLabel>Исходящий НДС (КС-3)</MetricLabel>
          <MetricValue>{formatMillions(tax.vat_outgoing_signed)}</MetricValue>
          <MetricNote>Начислено к уплате с реализации</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Входящий НДС (Закупки)</MetricLabel>
          <MetricValue>{formatMillions(tax.vat_incoming_deductible)}</MetricValue>
          <MetricNote>Принято к вычету по счетам-фактурам</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Чистый НДС к уплате (за квартал)</MetricLabel>
          <MetricValue $color={tax.net_vat_payable > 0 ? '#ef4444' : '#10b981'}>
            {formatMillions(tax.net_vat_payable)}
          </MetricValue>
          <MetricNote>Ежемесячный платёж (1/3 к 28-му числу): {formatMillions(tax.net_vat_payable / 3)}</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Резерв ЕНС на счёте</MetricLabel>
          <MetricValue $color="#8b5cf6">{formatMillions(tax.tax_reserve_balance)}</MetricValue>
          <MetricNote>Покрытие: <b>{tax.reserve_coverage_pct.toFixed(0)}%</b> от потребности</MetricNote>
        </MetricBox>
      </TaxSummaryGrid>
    </Section>
  );
}
